import { fetchWithCORSProxy } from '@elfsight/lib-utils';
import { getFilenameFromURL } from '@elfsight/widget-utils';

async function getTrackBlob(url: string, widgetToken?: string) {
  const cache = await window.caches?.open('es-player-cache');
  const cachedResponse = await cache?.match(url);
  if (cachedResponse) {
    return cachedResponse.blob();
  }

  try {
    let response: Response;

    try {
      response = await fetch(url);
    } catch (err) {
      response = await fetchWithCORSProxy(url, widgetToken);
    }

    if (!response.ok) {
      throw new Error(
        `HTTP request error ${response.status}` +
          (response.statusText ? ` - ${response.statusText}` : '')
      );
    }

    await cache?.put(url, response.clone());
    return await response.blob();
  } catch (e) {
    console.error('Download failed:', e);
    return null;
  }
}

export async function downloadTrack(url: string, widgetToken?: string) {
  if (!url) return;

  const filename = getFilenameFromURL(url) || 'track';

  const trackBlob = await getTrackBlob(url, widgetToken);
  if (!trackBlob) {
    return;
  }

  const blobUrl = URL.createObjectURL(trackBlob);

  const link = Object.assign(document.createElement('a'), {
    href: blobUrl,
    download: filename
  });

  link.click();
  link.remove();

  URL.revokeObjectURL(blobUrl);
}
